import {WuIcon} from '@/components/typography'
import {cn} from '@/lib/utils'
import React, {RefObject} from 'react'

interface IMenuTriggerProps {
  buttonRef: RefObject<HTMLButtonElement | null>
  handleDropdownToggle: (event: React.MouseEvent<HTMLButtonElement>) => void
  handleKeyDown: (
    e: React.KeyboardEvent<HTMLButtonElement>,
    index: number,
  ) => void
  isDropdownOpen: boolean
  activeProductName: string
  dir?: 'ltr' | 'rtl'
  homeLink?: string
}

export const MenuTrigger: React.FC<IMenuTriggerProps> = ({
  buttonRef,
  handleDropdownToggle,
  handleKeyDown,
  isDropdownOpen,
  activeProductName,
  dir = 'ltr',
  homeLink = '/',
}) => {
  return (
    <button
      ref={buttonRef}
      type="button"
      className={cn(
        'text-base font-normal flex items-center justify-between px-2 gap-2 w-full focus:outline-none focus-visible:bg-white/10 wu-switcher-trigger',
      )}
      onClick={handleDropdownToggle}
      onKeyDown={e => {
        if (isDropdownOpen && e.key === 'ArrowDown') {
          handleKeyDown(e, -1)
        }
      }}
      aria-label="product-switcher"
    >
      <a
        className="pl-2 pr-0 aspect-auto focus:outline-none focus-visible:bg-white/10 wu-switcher-logo"
        tabIndex={-1}
        href={homeLink}
      >
        <WuIcon icon="wc-logo" className="text-xl leading-4 relative top-1" />
      </a>
      {activeProductName}
      <span
        className={cn(
          'wm-arrow-drop-down text-2xl transition-transform duration-300',
          isDropdownOpen && 'rotate-180',
          dir === 'rtl' ? 'mr-auto' : 'ml-auto',
        )}
      />
    </button>
  )
}
